'use client';

import type { ReadonlyURLSearchParams } from '@nextgen-web-framework/all';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

type Props = {
  onExtractQueryParams: (params: ReadonlyURLSearchParams | null) => void;
};

export default function SearchParamsProvider({ onExtractQueryParams }: Props) {
  const searchParams = useSearchParams() as unknown as ReadonlyURLSearchParams | null;

  useEffect(() => {
    onExtractQueryParams(searchParams);
  }, [searchParams, onExtractQueryParams]);

  return null;
}
